import { render, staticRenderFns } from "./SettingOften.vue?vue&type=template&id=67563ad5&"
import script from "./SettingOften.vue?vue&type=script&lang=js&"
export * from "./SettingOften.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports